import { Reducer } from 'redux';

import { ICategoryPricesState } from 'types/categoryPrices.types';
import * as authConstants from 'redux/constants/auth.constants';
import * as constants from 'redux/constants/categoryPrices.constants';

export const defaultState: ICategoryPricesState = {
  count: 0,
  items: [],
  loading: false,
  selectedItem: null,
  table: {
    page: 1,
    limit: 10,
    search: '',
    sortKey: 'name',
    sortType: 'asc',
  },
};

const categoryPricesReducer: Reducer = (state = defaultState, action) => {
  const { data, type } = action;
  switch (type) {
    case constants.CATEGORY_PRICES_ON_DELETE_REQUESTED:
    case constants.CATEGORY_PRICES_ON_GET_ALL_REQUESTED:
    case constants.CATEGORY_PRICES_ON_SAVE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case constants.CATEGORY_PRICES_ON_GET_ONE_REQUESTED:
      return {
        ...state,
        loading: !!action.id,
        selectedItem: null,
      };
    case constants.CATEGORY_PRICES_ON_GET_ALL_SUCCEEDED:
      return {
        ...state,
        count: data.count,
        items: data.items,
        loading: false,
        table: data.table,
      };
    case constants.CATEGORY_PRICES_ON_GET_ONE_SUCCEEDED:
      return {
        ...state,
        loading: false,
        selectedItem: data.item,
      };
    case constants.CATEGORY_PRICES_ON_DELETE_SUCCEEDED:
    case constants.CATEGORY_PRICES_ON_SAVE_SUCCEEDED:
    case constants.CATEGORY_PRICES_ON_DELETE_FAILED:
    case constants.CATEGORY_PRICES_ON_GET_ALL_FAILED:
    case constants.CATEGORY_PRICES_ON_SAVE_FAILED:
      return {
        ...state,
        loading: false,
      };
    case constants.CATEGORY_PRICES_ON_GET_ONE_FAILED:
      return {
        ...state,
        loading: false,
        selectedItem: null,
      };
    case authConstants.AUTH_ON_LOGOUT_SUCCEEDED:
    case authConstants.AUTH_ON_LOGOUT_PUBLIC_SUCCEEDED:
      return defaultState;
    default:
      return state;
  }
};

export default categoryPricesReducer;
